var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[(_vm.layout != 'no-sidebar-layout')?_c('div',{staticClass:"sub-content-tab"}):_vm._e(),_c('router-view',{class:_vm.layout === 'no-sidebar-layout'?'':'route-position'})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }